export const homeObjOne = {
  id: "aboutme",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Michał Godun",
  headLine: "ReactJS Frontend Developer",
  description:
    "I'm frontend developer passionate about exploring new technologies, self-improvement and leveraging skills. Excellent team player with exceptional communication skills.",
  buttonLabel: "Contact Me",
  dest: "contact",
  imgStart: true,
  img: require("../../images/profil.jpg"),
  alt: "Photo",
  dark: true,
  primary: true,
  darkText: false,
};
export const homeObjTwo = {
  id: "technologies",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Technological stack",
  headLine: "JavaScript, HTML, CSS and ReactJS",
  description:
    "I'm able to create mobile responsive apps connected with API and deploy it.",
  buttonLabel: "Go to projects",
  dest: "projects",
  imgStart: false,
  img: require("../../images/technologies.svg"),
  alt: "Technologies",
  dark: false,
  primary: false,
  darkText: true,
};
